import { Badge } from '@mantine/core';
import { useTranslation } from '../context/TranslationContext';

// Marks a negative-quantity order line: money back, not goods. Amber rather than
// the green used for free items — it reduces the bill instead of granting one.
export default function RefundItemBadge() {
  const { t } = useTranslation();
  return (
    <Badge
      color="orange"
      size="xs"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
      }}
    >
      {t('refund', 'Refund')}
    </Badge>
  );
}
